import React from 'react';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <p>&copy; {year} Muv Cargo. All rights reserved.</p>
        <div className="footer-links">
          <a href="/privacy">Privacy Policy</a>
          <a href="/terms">Terms of Service</a>
          <a href="/contact">Contact</a>
        </div>
      </div>
      
  <style>{`
        .footer {
          background: #333;
          color: white;
          padding: 2rem 0;
          margin-top: auto;
        }
        
        .footer-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        
        .footer-links a {
          color: #ccc;
          text-decoration: none;
          margin-left: 1.5rem;
        }
        
        .footer-links a:hover {
          color: white;
        }
        
        @media (max-width: 768px) {
          .footer-container {
            flex-direction: column;
            gap: 1rem;
            text-align: center;
          }
          
          .footer-links a {
            margin: 0 0.75rem;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;